import React from "react";
import Image from "next/image";
import styles from "./projects.module.scss";
import { CloudfrontImageLoader, formatShortenedPrice } from "@/lib/helpers";
import { STATUS_MAP, TYPE_MAP } from "@/common/constants";

import { usePath } from "@/contexts/path/path";
import AppLink from "@/components/new-resolver/app.ink";
import config from "@/common/config";
import {
  trackExclusiveProjectClick,
  trackProjectClick,
} from "@/lib/tracking/trackExclusiveUnitBookingEvents";
import { useAuthState } from "@/contexts/auth/auth.provider";

export const getUrlForString = (value = "") =>
  value
    ?.toLowerCase()
    .trim()
    .replace(/(\s)?-(\s)?/g, "-")
    .replace(/\|/g, "")
    .replaceAll(" ", "-")
    .replaceAll("--", "-");
export function getProjectURL({ title, id, real_estate_developer }) {
  const segments = [
    "/المشاريع-العقارية",
    real_estate_developer ? getDeveloperUrl(real_estate_developer) : "",
    id ? getUrlForString(title + "-" + id) : "",
  ];

  return segments.filter(Boolean).join("/");
}

export function getDeveloperUrl(developer) {
  return getUrlForString(developer.name + "-" + developer.id);
}

export function getUnitUrl({ unitId, unitCode, ...project }) {
  return [getProjectURL(project), unitCode || unitId].join("/");
}
const ProjectCard = ({ project, priority }) => {
  const { previousPath } = usePath();
  const {
    imgs,
    project_status: projectStatus,
    project_type: projectType,
    starting_price: startingPrice,
    title,
    listing_categories: listingCategories,
    address,
    real_estate_developer: realEstateDeveloper,
    is_exclusive: isExclusive,
  } = project;

  const { categoriesDictionary, updateContext } = usePath();
  const user = useAuthState("user");
  const hasBrokerPermission = user?.permissions?.includes(
    "ACCESS_TO_INIT_REAL_ESTATE_PROJECT_PAYMENT_REQUEST",
  );

  const url = getProjectURL(project);

  const coverImage =
    Array.isArray(imgs) && imgs.length > 0 ? imgs[0] : "villa-default.png";
  const formattedPrice = `يبدأ من ${formatShortenedPrice(startingPrice)}`;

  return (
    <AppLink
      onClick={() => {
        if (isExclusive) {
          trackExclusiveProjectClick({
            target: hasBrokerPermission
              ? "instant_reservation_by_broker"
              : "instant_reservation_by_seeker",
          });
        }
        trackProjectClick({
          method: realEstateDeveloper?.logo_img
            ? "premium_project"
            : "standard_project",
          source: previousPath || encodeURI(document.referrer),
          projectName: title,
        });
        updateContext({
          developer: realEstateDeveloper,
          project: {
            ...project,
            url,
          },
        });
      }}
      path={url}
      scroll
    >
      <div className={styles.projectCard}>
        <div className={styles.projectImage}>
          <Image
            loader={CloudfrontImageLoader}
            src={`${config.IMAGES_BASE_URL}webp/640x0/props/${coverImage}`}
            fill
            alt={project.tilte}
            priority={priority}
            sizes="(max-width: 600px) 40vw, 100vw"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
            }}
          />
          <div className={styles.overlay}>
            <div className={styles.tags}>
              {projectStatus && (
                <div className={`${styles.metaChip} ${styles[projectStatus]}`}>
                  <span>{STATUS_MAP[projectStatus]}</span>
                </div>
              )}
              {projectType && (
                <div className={styles.metaChip}>
                  <span>{TYPE_MAP[projectType]}</span>
                </div>
              )}
              {isExclusive && (
                <div className={`${styles.metaChip}`}>
                  <span>حجز فوري</span>
                </div>
              )}
            </div>
            <div className={styles.startingPrice}>{formattedPrice}</div>
          </div>
        </div>
        <div className={styles.midSection}>
          <div className={styles.right}>
            <h3 className={styles.projectTitle}>{title}</h3>
            {!!listingCategories?.length && (
              <div className={styles.categoriesList}>
                {listingCategories.map((id) => (
                  <div className={styles.metaChip} key={id}>
                    <span>{categoriesDictionary?.[id]?.name}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className={styles.left}>
            <div className={styles.logo}>
              <Image
                unoptimized
                src={`https://cdn.aqar.fm/projects/${realEstateDeveloper?.logo_img}`}
                fill
                priority={priority}
                alt="logo"
                sizes="(max-width: 600px) 40vw, 100vw"
              />
            </div>
          </div>
        </div>
        <div>
          <div className={styles.address}>{address}</div>
        </div>
      </div>
    </AppLink>
  );
};

export default ProjectCard;
